<template>
    <div class="flex flex-col gap-8 container">
        <div class="view-h2 w-full col-span-full">{{get_localized_value(content?.title) }}</div>
        <div class="flex flex-col gap-16 md:gap-4 lg:col-start-2 col-span-13 lg:col-span-9">
            <div v-for="item in content?.items" class="flex flex-col md:flex-row gap-4 items-center md:grid md:grid-cols-11 lg:grid-cols-9 md:!col-start-1">
                <img :src="`/api/files/image/${item.image}`" class="w-full md:col-span-6 self-end rounded-sm !col-start-1"/>
                <div class="col-start-7 col-span-5 flex flex-col gap-4">
                    <h4 class="view-h4 uppercase">{{ get_localized_value(item?.title)}}</h4>
                    <div>{{ get_localized_value(item?.body)}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import type { LocalizedText } from "#layers/cms/shared/types/bucketData"

const {get_value: get_localized_value} = useLocalizedValue()

const {content} = defineProps({
    content: Object as PropType<{
        title: LocalizedText,
        items: {image: string, title: LocalizedText, body: LocalizedText}[]
    }>
})
</script>